import React from "react";
import PropTypes from "prop-types";

import TakisPicture from "./TakisPicture";
import TakisBackgroundVideo from "./TakisBackgroundVideoPlayer";

import {useStyles} from "./TakisHeroVideo.styles"
import TakisDivider from "./TakisDivider";
import { Link } from "@material-ui/core";
const TakisHeroVideo = ({
  bgImages,
  inlineVideos,
  altText,
  isActive,
  userPaused,
  ctaUrl
}) => {
  const classes = useStyles();

  // Holds both overlapping video and background images.
  // Note that while a srcset array is used for Images
  // Background video only changes sources on MD breakpoint.
  return (
    <Link
      className={classes.heroVideo}
      href={isActive ? ctaUrl : ''}
      title={altText}
      target="_blank"
      aria-hidden={!isActive}
      >
      {
        bgImages &&
        <TakisPicture
          pictureClass={classes.heroVideo_image}
          images={bgImages}
          isLazy={false}
          altText={altText}
          />
      }
      <TakisBackgroundVideo
        className={classes.heroVideo_video}
        inlineVideos={inlineVideos}
        isActive={isActive}
        userPaused={userPaused}
        />
      {/* INNER CAROUSEL DIVIDER */}
      <TakisDivider
        modifier={classes.heroVideo_divider}
        marginModifier={classes.heroVideo_divider_margin}
        variation={1}
      />
    </Link>
  )
};


TakisHeroVideo.propTypes = {
  bgImages: PropTypes.array,
  inlineVideos: PropTypes.object,
  altText: PropTypes.string,
  isActive: PropTypes.bool,
  ctaUrl: PropTypes.string
};

export default TakisHeroVideo;
